// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import styled from 'styled-components';
import HamLink from '../../_common/form/HamLink';
import Icon from '../../_common/form/Icon';

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    flex-grow: 1;
    padding: 0.5em;
    position: relative;
    background-color: ${({ theme }) => theme.white};
    margin: 1em;
`
const IconWrapper = styled.div`
    position: absolute;
    top: -60%;
    display: flex;
    height: 2em;
    width: 2em;
    background-color: ${({ theme }) => theme.tertiary};
    border-radius: 50%;
    top: 0.5emx;
    display: flex;
    justify-content: center;
    align-items: center;
`
const I = styled(Icon)`
    font-size: 1.1em;
    color: ${({ theme }) => theme.contrast};
`

const ContactCards = ({ type, value }) => {
    return (
        <Wrapper>
            <IconWrapper>
                <I icon={type === 'phone' ? 'phone' : 'envelope'} />
            </IconWrapper>
            <HamLink href={(type === 'phone' ? 'tel:' : 'mailto:') + value}>
                {value}
            </HamLink>
        </Wrapper>
    );
}

export default ContactCards;